import { findKey } from "@js/object-tool.js";
import { DateTool } from "@js/date-tool.js";
import dayjs from "dayjs";

window.USER_GENDER = {
  男: 1,
  女: 2
};

window.SLEEP_EPRIOD = {
  清醒期: 0,
  眼动期: 2,
  浅睡期: 3,
  深睡期: 4
};

class ReportDetailModel {
  constructor(reportDetail) {
    this.reportDetail = reportDetail.reportDetail; //为了引用方便
    this.reportUser = reportDetail.reportUser; //为了引用方便
    this.sleepOxygenReportConfig = reportDetail.sleepOxygenReportConfig;
    //用户信息
    this.nameStr = placeholderText(this.reportUser.name);
    this.genderStr = placeholderText(findKey(USER_GENDER, this.reportUser.sex));
    this.heightStr = placeholderText(this.reportUser.height, "cm");
    this.weightStr = placeholderText(this.reportUser.weight, "kg");
    this.bmiStr = placeholderText(this.reportUser.bmi);
    this.bedNumber = placeholderText(this.reportUser.bedNumber);
    this.medicalRecordNumber = placeholderText(this.reportUser.medicalRecordNumber);
    this.doctorName = placeholderText(this.reportUser.doctorName);
    this.ageStr = this._initAgeStr();
    this.deviceNumber = placeholderText(this.reportDetail.deviceNumber);
    this.sn = placeholderText(this.reportDetail.sn);
    this.idCardStr = placeholderText(this.reportUser.idCard);
    this.gestationalWeekStr = placeholderText(this.reportUser.gestationalWeek);
    this.mobileStr = placeholderText(this.reportUser.mobile);

    // HRV数据
    this.hrvData = reportDetail.hrvData;
    this.hrvScatterData = this._initHrvScatterData(reportDetail?.hrvData?.hrVect);
    this.hrvDistributionData = this._initHrvDistribution(reportDetail?.hrvData?.histVect)
    this.hrvFrequencyData = this._initHrvFrequency(reportDetail?.hrvData?.freqVect)

    // 新版报告显隐配置
    this.sleepStructureModuleConfig = this.sleepOxygenReportConfig?.sleepStructureModuleConfig
      ? JSON.parse(this.sleepOxygenReportConfig.sleepStructureModuleConfig)
      : [];
    this.spo2PulseModuleConfig = this.sleepOxygenReportConfig?.spo2PulseModuleConfig
      ? JSON.parse(this.sleepOxygenReportConfig.spo2PulseModuleConfig)
      : [];

    //儿童模式
    this.reportModeType = reportDetail.modeType; //0成人1儿童（同睡眠）

    //模版类型
    this.xyReportTemplateType = reportDetail.xyReportTemplateType;

    //基础信息
    this.reportId = this.reportDetail.id;
    this.startTimeStr = placeholderText(reportDetail.startTime);
    this.endTimeStr = placeholderText(reportDetail.endTime);
    this.totalSleepTimeStr = placeholderText(reportDetail.totalTime);
    this.sopReportHeaders = reportDetail.sopReportHeaders;
    this.sopReportSubTitle = reportDetail.sopReportSubTitle;
    this.sopReportLogo = reportDetail.sopReportLogo;

    // 打印模式下的标题字段
    this.printFirstPageTitle = this.sleepOxygenReportConfig?.spo2PulseSecondaryTitle;
    this.printSecondPageTitle = this.sleepOxygenReportConfig?.sleepStructureSecondaryTitle;

    //血氧饱和度统计
    this.averageBloodOxygen = placeholderText(this.reportDetail.avgO2, "%");
    this.minBloodOxygen = placeholderText(this.reportDetail.minO2, "%");
    this.bloodOxygenUnder95TimeStr = placeholderText(this.reportDetail.secondsUnder95);
    this.bloodOxygenUnder90TimeStr = placeholderText(this.reportDetail.secondsUnder90);
    this.bloodOxygenUnder85TimeStr = placeholderText(this.reportDetail.secondsUnder85);
    this.bloodOxygenUnder80TimeStr = placeholderText(this.reportDetail.secondsUnder80);
    this.bloodOxygenUnder70TimeStr = placeholderText(this.reportDetail.secondsUnder70);
    this.bloodOxygenUnder60TimeStr = placeholderText(this.reportDetail.secondsUnder60);
    this.bloodOxygenUnder95Ratio = this.reportDetail.shareUnder95;
    this.bloodOxygenUnder90Ratio = this.reportDetail.shareUnder90;
    this.bloodOxygenUnder85Ratio = this.reportDetail.shareUnder85;
    this.bloodOxygenUnder80Ratio = this.reportDetail.shareUnder80;
    this.bloodOxygenUnder70Ratio = this.reportDetail.shareUnder70;
    this.bloodOxygenUnder60Ratio = this.reportDetail.shareUnder60;
    this.bloodOxygenUnder95RatioStr = placeholderText(
      this.reportDetail.shareUnder95?.toFixed(3),
      "%"
    );
    this.bloodOxygenUnder90RatioStr = placeholderText(
      this.reportDetail.shareUnder90?.toFixed(3),
      "%"
    );
    this.bloodOxygenUnder85RatioStr = placeholderText(
      this.reportDetail.shareUnder85?.toFixed(3),
      "%"
    );
    this.bloodOxygenUnder80RatioStr = placeholderText(
      this.reportDetail.shareUnder80?.toFixed(3),
      "%"
    );
    this.bloodOxygenUnder70RatioStr = placeholderText(
      this.reportDetail.shareUnder70?.toFixed(3),
      "%"
    );
    this.bloodOxygenUnder60RatioStr = placeholderText(
      this.reportDetail.shareUnder60?.toFixed(3),
      "%"
    );

    //氧减统计
    this.downTimesOver4Str = placeholderText(this.reportDetail.downTimes4?.toFixed(0));
    this.downIndexOver4Str = placeholderText(this.reportDetail.downIndex4);
    this.downTimesOver3Str = placeholderText(this.reportDetail.downTimes?.toFixed(0));
    this.downIndexOver3Str = placeholderText(this.reportDetail.downIndex);
    this.odiIndex = this.reportDetail.downIndex;
    this.maxDownDuration = placeholderText(this.reportDetail.maxDownDuration);

    //氧减事件统计
    this.oxygenMinusEventLess100TimesStr = placeholderText(
      this.reportDetail.odi3Less100Cnt?.toFixed(0)
    );
    this.oxygenMinusEventLess95TimesStr = placeholderText(
      this.reportDetail.odi3Less95Cnt?.toFixed(0)
    );
    this.oxygenMinusEventLess90TimesStr = placeholderText(
      this.reportDetail.odi3Less90Cnt?.toFixed(0)
    );
    this.oxygenMinusEventLess85TimesStr = placeholderText(
      this.reportDetail.odi3Less85Cnt?.toFixed(0)
    );
    this.oxygenMinusEventLess80TimesStr = placeholderText(
      this.reportDetail.odi3Less80Cnt?.toFixed(0)
    );
    this.oxygenMinusEventLess75TimesStr = placeholderText(
      this.reportDetail.odi3Less75Cnt?.toFixed(0)
    );
    this.oxygenMinusEventLess70TimesStr = placeholderText(
      this.reportDetail.odi3Less70Cnt?.toFixed(0)
    );
    this.oxygenMinusEventLess65TimesStr = placeholderText(
      this.reportDetail.odi3Less65Cnt?.toFixed(0)
    );
    this.oxygenMinusEventLess60TimesStr = placeholderText(
      this.reportDetail.odi3Less60Cnt?.toFixed(0)
    );

    this.oxygenMinusEventLess100Ratio = this.reportDetail.odi3Less100Percent;
    this.oxygenMinusEventLess95Ratio = this.reportDetail.odi3Less95Percent;
    this.oxygenMinusEventLess90Ratio = this.reportDetail.odi3Less90Percent;
    this.oxygenMinusEventLess85Ratio = this.reportDetail.odi3Less85Percent;
    this.oxygenMinusEventLess80Ratio = this.reportDetail.odi3Less80Percent;
    this.oxygenMinusEventLess75Ratio = this.reportDetail.odi3Less75Percent;
    this.oxygenMinusEventLess70Ratio = this.reportDetail.odi3Less70Percent;
    this.oxygenMinusEventLess65Ratio = this.reportDetail.odi3Less65Percent;
    this.oxygenMinusEventLess60Ratio = this.reportDetail.odi3Less60Percent;

    this.oxygenMinusEventLess100RatioStr = placeholderText(
      this.reportDetail.odi3Less100Percent?.toFixed(1),
      "%"
    );
    this.oxygenMinusEventLess95RatioStr = placeholderText(
      this.reportDetail.odi3Less95Percent?.toFixed(1),
      "%"
    );
    this.oxygenMinusEventLess90RatioStr = placeholderText(
      this.reportDetail.odi3Less90Percent?.toFixed(1),
      "%"
    );
    this.oxygenMinusEventLess85RatioStr = placeholderText(
      this.reportDetail.odi3Less85Percent?.toFixed(1),
      "%"
    );
    this.oxygenMinusEventLess80RatioStr = placeholderText(
      this.reportDetail.odi3Less80Percent?.toFixed(1),
      "%"
    );
    this.oxygenMinusEventLess75RatioStr = placeholderText(
      this.reportDetail.odi3Less75Percent?.toFixed(1),
      "%"
    );
    this.oxygenMinusEventLess70RatioStr = placeholderText(
      this.reportDetail.odi3Less70Percent?.toFixed(1),
      "%"
    );
    this.oxygenMinusEventLess65RatioStr = placeholderText(
      this.reportDetail.odi3Less65Percent?.toFixed(1),
      "%"
    );
    this.oxygenMinusEventLess60RatioStr = placeholderText(
      this.reportDetail.odi3Less60Percent?.toFixed(1),
      "%"
    );

    //氧减时间统计
    this.oxygenMinusTimeLess10TimesStr = placeholderText(
      this.reportDetail.odi3Less10sCnt?.toFixed(0)
    );
    this.oxygenMinusTimeLess20TimesStr = placeholderText(
      this.reportDetail.odi3Less20sCnt?.toFixed(0)
    );
    this.oxygenMinusTimeLess30TimesStr = placeholderText(
      this.reportDetail.odi3Less30sCnt?.toFixed(0)
    );
    this.oxygenMinusTimeLess40TimesStr = placeholderText(
      this.reportDetail.odi3Less40sCnt?.toFixed(0)
    );
    this.oxygenMinusTimeLess50TimesStr = placeholderText(
      this.reportDetail.odi3Less50sCnt?.toFixed(0)
    );
    this.oxygenMinusTimeLess60TimesStr = placeholderText(
      this.reportDetail.odi3Less60sCnt?.toFixed(0)
    );
    this.oxygenMinusTimeMore60TimesStr = placeholderText(
      this.reportDetail.odi3Longer60sCnt?.toFixed(0)
    );

    this.oxygenMinusTimeLess10Ratio = this.reportDetail.odi3Less10sPercent;
    this.oxygenMinusTimeLess20Ratio = this.reportDetail.odi3Less20sPercent;
    this.oxygenMinusTimeLess30Ratio = this.reportDetail.odi3Less30sPercent;
    this.oxygenMinusTimeLess40Ratio = this.reportDetail.odi3Less40sPercent;
    this.oxygenMinusTimeLess50Ratio = this.reportDetail.odi3Less50sPercent;
    this.oxygenMinusTimeLess60Ratio = this.reportDetail.odi3Less60sPercent;
    this.oxygenMinusTimeMore60Ratio = this.reportDetail.odi3Longer60sPercent;

    this.oxygenMinusTimeLess10RatioStr = placeholderText(
      this.reportDetail.odi3Less10sPercent?.toFixed(1),
      "%"
    );
    this.oxygenMinusTimeLess20RatioStr = placeholderText(
      this.reportDetail.odi3Less20sPercent?.toFixed(1),
      "%"
    );
    this.oxygenMinusTimeLess30RatioStr = placeholderText(
      this.reportDetail.odi3Less30sPercent?.toFixed(1),
      "%"
    );
    this.oxygenMinusTimeLess40RatioStr = placeholderText(
      this.reportDetail.odi3Less40sPercent?.toFixed(1),
      "%"
    );
    this.oxygenMinusTimeLess50RatioStr = placeholderText(
      this.reportDetail.odi3Less50sPercent?.toFixed(1),
      "%"
    );
    this.oxygenMinusTimeLess60RatioStr = placeholderText(
      this.reportDetail.odi3Less60sPercent?.toFixed(1),
      "%"
    );
    this.oxygenMinusTimeMore60RatioStr = placeholderText(
      this.reportDetail.odi3Longer60sPercent?.toFixed(1),
      "%"
    );

    //脉率统计
    this.averagePulseStr = placeholderText(this.reportDetail.avgPr, "bpm");
    this.maxPulseStr = placeholderText(this.reportDetail.maxPr, "bpm");
    this.minPulseStr = placeholderText(this.reportDetail.minPr, "bpm");

    //HRV
    this.sdnn = placeholderText(this.reportDetail.sdnn);

    //睡眠分期统计
    this.totalHoursStr = placeholderText(
      DateTool.formatSeconds(this.reportDetail.sleepMinutes * 60)
    );
    this.lightHoursStr = placeholderText(
      DateTool.formatSeconds(this.reportDetail.lightMinutes * 60)
    );
    this.deepHoursStr = placeholderText(DateTool.formatSeconds(this.reportDetail.deepMinutes * 60));
    this.remHoursStr = placeholderText(DateTool.formatSeconds(this.reportDetail.remMinutes * 60));

    this.totalTimeStr = placeholderText(this.reportDetail.sleepMinutes?.toFixed(0), "分钟");
    this.wakeMinutesStr = placeholderText(this.reportDetail.wakeMinutes?.toFixed(0), "分钟");
    this.remMinutesStr = placeholderText(this.reportDetail.remMinutes?.toFixed(0), "分钟");
    this.lightMinutesStr = placeholderText(this.reportDetail.lightMinutes?.toFixed(0), "分钟");
    this.deepMinutesStr = placeholderText(this.reportDetail.deepMinutes?.toFixed(0), "分钟");

    this.wakeMinutesTestPercentStr = placeholderText(
      this.reportDetail.wakeMinutesTestPercent?.toFixed(1),
      "%"
    );
    this.remMinutesTestPercentStr = placeholderText(
      this.reportDetail.remMinutesTestPercent?.toFixed(1),
      "%"
    );
    this.lightMinutesTestPercentStr = placeholderText(
      this.reportDetail.lightMinutesTestPercent?.toFixed(1),
      "%"
    );
    this.deepMinutesTestPercentStr = placeholderText(
      this.reportDetail.deepMinutesTestPercent?.toFixed(1),
      "%"
    );

    this.wakeMinutesSleepPercentStr = placeholderText(null);
    this.remMinutesSleepPercentStr = placeholderText(
      this.reportDetail.remMinutesSleepPercent?.toFixed(1),
      "%"
    );
    this.lightMinutesSleepPercentStr = placeholderText(
      this.reportDetail.lightMinutesSleepPercent?.toFixed(1),
      "%"
    );
    this.deepMinutesSleepPercentStr = placeholderText(
      this.reportDetail.deepMinutesSleepPercent?.toFixed(1),
      "%"
    );

    this.remMinutesSleepPercent = this.reportDetail.remMinutesSleepPercent;
    this.lightMinutesSleepPercent = this.reportDetail.lightMinutesSleepPercent;
    this.deepMinutesSleepPercent = this.reportDetail.deepMinutesSleepPercent;

    //趋势图
    this.bloodOxygenTrandArray = this._initBloodOxygenTrandArray();
    this.pulseTrandArray = this._initPulseTrandArray();
    this.periodTrandArray = this._initPeriodTrandArray();
    this.remMinBloodOxygen = this._initRemMinBloodOxygen();
    this.nremMinBloodOxygen = this._initNremMinBloodOxygen();
    this.newAverageBloodOxygen = this._initAverageBloodOxygen();

    //意见和建议
    //为了设置的粗细和字体正常显示，需要在reset.css文件中把b标签的"font: inherit"注释掉
    this.suggestContent = this.reportDetail.suggestContent;
    this.oxygenSummary = this.reportDetail.oxygenSummary;
    this.sleepSummary = this.reportDetail.sleepSummary;
    this.doctorSignature = this.reportDetail.doctorSignature; //没有不显示
    this.signatureDate = this.reportDetail.signatureDate; //没有不显示
    ({ TST: this.TST, maxDuration: this.tstMaxDuration } = this.calculateOxygenDrop(
      this.reportDetail.spo2EvtVect3,
      this.bloodOxygenTrandArray
    ));
  }

  _initBloodOxygenTrandArray() {
    const bloodOxygenTrandArray = [];
    if (!this.reportDetail.o2Arr || !Array.isArray(this.reportDetail.o2Arr)) {
      return bloodOxygenTrandArray;
    }
    this.reportDetail.o2Arr.forEach((bloodOxygen, index) => {
      const timestamp = this.reportDetail.startAt + index * 1000;
      const bloodOxygenTrand = [timestamp, bloodOxygen];
      bloodOxygenTrandArray.push(bloodOxygenTrand);
    });
    this.removeEmptyElements(bloodOxygenTrandArray);
    return bloodOxygenTrandArray;
  }

  _initPulseTrandArray() {
    const pulseTrandArray = [];
    if (!this.reportDetail.prArr || !Array.isArray(this.reportDetail.prArr)) {
      return pulseTrandArray;
    }
    this.reportDetail.prArr.forEach((pulse, index) => {
      const timestamp = this.reportDetail.startAt + index * 1000;
      const pulseTrand = [timestamp, pulse];
      pulseTrandArray.push(pulseTrand);
    });
    this.removeEmptyElements(pulseTrandArray);
    return pulseTrandArray;
  }

  _initAgeStr() {
    if (!this.reportUser.birthday) {
      return placeholderText(this.reportUser.age);
    }
    const birthDay = dayjs(this.reportUser.birthday);
    const baseDate = dayjs(this.reportDetail.startTime).toDate();
    return DateTool.calculateAgeWithBaseDate(
      birthDay.year(),
      birthDay.month() + 1,
      birthDay.date(),
      baseDate
    );
  }

  removeEmptyElements(arr) {
    // 去掉头部空元素
    while (arr.length > 0 && arr[0][1] === 0) {
      arr.shift();
    }
    // 去掉尾部空元素
    while (arr.length > 0 && arr[arr.length - 1][1] === 0) {
      arr.pop();
    }
    return arr;
  }

  _initPeriodTrandArray() {
    const periodTrandArray = [];
    //rawStageArr
    if (!this.reportDetail.stageArr || !Array.isArray(this.reportDetail.stageArr)) {
      return periodTrandArray;
    }
    const rawStageArr = this.reportDetail.stageArr.map((item, index) => {
      let value;
      switch (item) {
        case SLEEP_EPRIOD.清醒期:
          value = 4;
          break;
        case SLEEP_EPRIOD.眼动期:
          value = 3;
          break;
        case SLEEP_EPRIOD.浅睡期:
          value = 2;
          break;
        case SLEEP_EPRIOD.深睡期:
          value = 1;
          break;
        default:
          value = null;
          break;
      }
      return { value, index };
    });
    //stageArr
    removeEmptyElements(rawStageArr);
    //periodTrandArray
    rawStageArr.forEach((item) => {
      const timestamp = this.reportDetail.startAt + item.index * 60000;
      const periodTrand = [timestamp, item.value];
      periodTrandArray.push(periodTrand);
    });
    return periodTrandArray;

    function removeEmptyElements(arr) {
      // 去掉头部空元素
      while (arr.length > 0 && arr[0].value === null) {
        arr.shift();
      }
      // 去掉尾部空元素
      while (arr.length > 0 && arr[arr.length - 1].value === null) {
        arr.pop();
      }
      return arr;
    }
  }

  _initRemMinBloodOxygen() {
    const remBloodOxygenMinValues = [];

    // 先初始化血氧数据数组和睡眠分期数组
    const bloodOxygenTrandArray = this._initBloodOxygenTrandArray();
    const periodTrandArray = this._initPeriodTrandArray();

    if (
      !periodTrandArray ||
      periodTrandArray.length === 0 ||
      !bloodOxygenTrandArray ||
      bloodOxygenTrandArray.length === 0
    ) {
      return "-";
    }

    // 从periodTrandArray中筛选出眼动期(值为3)的数据
    const remPeriods = periodTrandArray.filter(
      ([timestamp, value]) => value === 3 // 3为眼动期
    );

    // 为每个REM期间收集血氧最小值
    remPeriods.forEach(([periodTimestamp, value]) => {
      const startTimestamp = periodTimestamp;
      const endTimestamp = startTimestamp + 60000; // 每个睡眠期持续1分钟

      // 在血氧数据中找到对应时间段的数据
      const bloodOxygenInPeriod = bloodOxygenTrandArray.filter(
        ([timestamp]) => timestamp >= startTimestamp && timestamp < endTimestamp
      );

      if (bloodOxygenInPeriod.length > 0) {
        // 找到这段时间内血氧的最小值
        const bloodOxygenValues = bloodOxygenInPeriod.map(([, value]) => value);
        const minBloodOxygen = Math.min(...bloodOxygenValues);
        remBloodOxygenMinValues.push(minBloodOxygen);
      }
    });

    // 从所有REM期的最小值中找到全局最小值
    if (remBloodOxygenMinValues.length > 0) {
      const globalMinBloodOxygen = Math.min(...remBloodOxygenMinValues);
      return globalMinBloodOxygen + " %";
    }

    return "-";
  }

  _initNremMinBloodOxygen() {
    const nremBloodOxygenMinValues = [];

    // 先初始化血氧数据数组和睡眠分期数组
    const bloodOxygenTrandArray = this._initBloodOxygenTrandArray();
    const periodTrandArray = this._initPeriodTrandArray();

    if (
      !periodTrandArray ||
      periodTrandArray.length === 0 ||
      !bloodOxygenTrandArray ||
      bloodOxygenTrandArray.length === 0
    ) {
      return "-";
    }

    // 从periodTrandArray中筛选出浅睡期(值为2)和深睡期(值为1)的数据
    const nremPeriods = periodTrandArray.filter(
      ([timestamp, value]) => value === 1 || value === 2 // 1为深睡期，2为浅睡期
    );

    // 为每个NREM期间收集血氧最小值
    nremPeriods.forEach(([periodTimestamp, value]) => {
      const startTimestamp = periodTimestamp;
      const endTimestamp = startTimestamp + 60000; // 每个睡眠期持续1分钟

      // 在血氧数据中找到对应时间段的数据
      const bloodOxygenInPeriod = bloodOxygenTrandArray.filter(
        ([timestamp]) => timestamp >= startTimestamp && timestamp < endTimestamp
      );

      if (bloodOxygenInPeriod.length > 0) {
        // 找到这段时间内血氧的最小值
        const bloodOxygenValues = bloodOxygenInPeriod.map(([, value]) => value);
        const minBloodOxygen = Math.min(...bloodOxygenValues);
        nremBloodOxygenMinValues.push(minBloodOxygen);
      }
    });

    // 从所有NREM期的最小值中找到全局最小值
    if (nremBloodOxygenMinValues.length > 0) {
      const globalMinBloodOxygen = Math.min(...nremBloodOxygenMinValues);
      return globalMinBloodOxygen + " %";
    }

    return "-";
  }

  _initAverageBloodOxygen() {
    const wakeBloodOxygenValues = [];

    // 先初始化血氧数据数组和睡眠分期数组
    const bloodOxygenTrandArray = this._initBloodOxygenTrandArray();
    const periodTrandArray = this._initPeriodTrandArray();

    if (
      !periodTrandArray ||
      periodTrandArray.length === 0 ||
      !bloodOxygenTrandArray ||
      bloodOxygenTrandArray.length === 0
    ) {
      return "-";
    }

    // 从periodTrandArray中筛选出清醒期(值为4)的数据
    const wakePeriods = periodTrandArray.filter(
      ([timestamp, value]) => value === 4 // 4为清醒期
    );

    // 为每个清醒期间收集血氧值
    wakePeriods.forEach(([periodTimestamp, value]) => {
      const startTimestamp = periodTimestamp;
      const endTimestamp = startTimestamp + 60000; // 每个睡眠期持续1分钟

      // 在血氧数据中找到对应时间段的数据
      const bloodOxygenInPeriod = bloodOxygenTrandArray.filter(
        ([timestamp]) => timestamp >= startTimestamp && timestamp < endTimestamp
      );

      if (bloodOxygenInPeriod.length > 0) {
        // 收集这段时间内的所有血氧值，并过滤掉值为0的数据
        const bloodOxygenValues = bloodOxygenInPeriod
          .map(([, value]) => value)
          .filter((value) => value > 0); // 过滤掉血氧值为0的数据
        wakeBloodOxygenValues.push(...bloodOxygenValues);
      }
    });

    // 计算清醒期血氧的平均值
    if (wakeBloodOxygenValues.length > 0) {
      const sum = wakeBloodOxygenValues.reduce((acc, value) => acc + value, 0);
      const rawAverage = sum / wakeBloodOxygenValues.length;
      const average = (Math.floor(rawAverage * 10) / 10).toFixed(1);
      if (parseInt(average) === parseInt(this.reportDetail.avgO2)) {
        return this.reportDetail.avgO2 + " %";
      } else {
        return average + " %";
      }
    }

    return "-";
  }

  calculateOxygenDrop(spo2EvtVect3, o2Arr) {
    let maxTST = 0;
    let maxDuration = 0;

    // 添加空值检查
    if (!spo2EvtVect3 || !Array.isArray(spo2EvtVect3) || !o2Arr || !Array.isArray(o2Arr)) {
      return { TST: maxTST, maxDuration };
    }

    // 将氧减事件分组处理（每2个为一组）
    for (let i = 0; i < spo2EvtVect3.length; i += 2) {
      const startTimestamp = spo2EvtVect3[i] * 1000; // 转换为毫秒
      const duration = spo2EvtVect3[i + 1];
      const endTimestamp = startTimestamp + duration * 1000;

      // 在血氧数据中筛选对应时间段的数据
      const pointsInRange = o2Arr.filter(([ts]) => ts >= startTimestamp && ts <= endTimestamp);

      if (pointsInRange.length === 0) continue;

      // 提取血氧值并计算极值
      const values = pointsInRange.map(([, val]) => val);
      const currentDrop = Math.max(...values) - Math.min(...values);

      // 更新最大值记录
      if (currentDrop > maxTST || (currentDrop === maxTST && duration > maxDuration)) {
        maxTST = currentDrop;
        maxDuration = duration;
      }
    }

    return { TST: maxTST, maxDuration };
  }

  _initHrvScatterData(hrVect) {
    if (!hrVect) {
      return [];
    }

    let dataArray = [];

    // 如果是字符串，尝试解析为数组
    if (typeof hrVect === 'string') {
      try {
        dataArray = JSON.parse(hrVect);
      } catch (error) {
        return [];
      }
    } else if (Array.isArray(hrVect)) {
      // 如果已经是数组，直接使用
      dataArray = hrVect;
    } else {
      // 其他情况返回空数组
      return [];
    }

    // 确保数组是有效的
    if (!Array.isArray(dataArray) || dataArray.length === 0) {
      return [];
    }

    // 如果数组长度为奇数，去除最后一个元素使其变成偶数
    if (dataArray.length % 2 !== 0) {
      dataArray = dataArray.slice(0, -1);
    }

    // 将一维数组转换为二维数组：[x1,y1,x2,y2,...] => [[x1,y1],[x2,y2],...]
    const scatterData = [];
    for (let i = 0; i < dataArray.length; i += 2) {
      const x = dataArray[i];     // 奇数位索引：0,2,4... 作为x轴
      const y = dataArray[i + 1]; // 偶数位索引：1,3,5... 作为y轴

      // 确保x和y都是有效数值
      if (typeof x === 'number' && typeof y === 'number' && !isNaN(x) && !isNaN(y)) {
        scatterData.push([x, y]);
      }
    }

    return scatterData;
  }

  _initHrvDistribution(hisVect) {
    if (!hisVect) {
      return [];
    }

    let dataArray = [];

    // 如果是字符串，尝试解析为数组
    if (typeof hisVect === 'string') {
      dataArray = JSON.parse(hisVect);
    } else if (Array.isArray(hisVect)) {
      dataArray = hisVect;
    } else {
      // 其他情况返回空数组
      return [];
    }
    return dataArray;
  }
  _initHrvFrequency(freqVect) {
    if (!freqVect) {
      return [];
    }
    let dataArray = [];
    // 如果是字符串，尝试解析为数组
    if (typeof freqVect === 'string') {
      dataArray = JSON.parse(freqVect);
    } else if (Array.isArray(freqVect)) {
      dataArray = freqVect;
    } else {
      // 其他情况返回空数组
      return [];
    }
    return dataArray;
  }

  isShowHRV() {
    return this.xyReportTemplateType == window.SPO2_REPORT_TEMPLATE?.中国曲棍球国家代表队
  }

  isShowLiteTable() {
    return this.xyReportTemplateType == window.SPO2_REPORT_TEMPLATE?.广东医科大学附属第二医院
  }

  isShowIntended() {
    switch (this.xyReportTemplateType) {
        case window.SPO2_REPORT_TEMPLATE?.沧州中心医院:
          return true;
        default:
          return false;
      }
  }
}

export { ReportDetailModel };
